import { axiosApi } from "services/api";

// API function to get all campaigns for a creator
export const getAllCampaignsForCreator = async (token, page, data = {}) => {
    try {
        const response = await axiosApi.post(`/campaigns/get?page=${page}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error; // Throw error to be handled in the action
    }
};

// API function to get a single brand's details
export const getSingleBrand = async (token, data) => {
    try {
        const response = await axiosApi.post("/get/brand", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error; // Throw the error to be handled by action
    }
};

// API function to get reviews for a brand
export const getReviewsForBrand = async (token, data) => {
    try {
        const response = await axiosApi.post("/collaboration/brand/reviews/get", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error; // Throw the error to be handled by action
    }
};